var _ellipse, _path, _circle, _path2, _ellipse2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path5, _path6, _path7, _path8, _path9, _path10, _circle2, _circle3, _circle4, _circle5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 104,
    viewBox: "0 0 395 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.2884,
    cy: 36.5661,
    rx: 37.0991,
    ry: 36.5661,
    fill: "#FFBA07"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.024 73.132C110.217 73.132 106.412 73.132 84.6862 73.132C62.9605 73.132 66.1896 73.132 45.3483 73.132C45.3483 63.0051 62.9605 54.7957 84.6862 54.7957C106.412 54.7957 124.024 63.0051 124.024 73.132Z",
    fill: "#2D2D2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.7299,
    cy: 31.129,
    r: 2.13213,
    fill: "#09DE1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.654 59.6096C60.3776 58.7128 63.5785 57.6302 65.0884 57.2009C58.2234 50.9539 58.0555 35.9365 58.8297 29.2087C62.3881 30.0813 65.1327 40.1445 66.0602 45.0671C67.5591 37.7446 64.6233 30.4534 62.9681 27.7231C65.3074 25.3704 71.1936 26.4094 73.8443 27.223C59.4594 17.9541 58.9636 23.8056 57.9502 22.5569C57.1394 21.558 58.6383 19.503 59.4891 18.6003C57.6574 18.6846 56.147 20.7689 55.6208 21.8005C54.9072 19.5882 51.2876 19.0494 49.567 19.0566C51.1093 19.3311 52.491 21.6566 52.9891 22.785C41.0824 23.3326 39.5016 28.8742 40.1995 31.5765C41.2226 27.2119 49.271 26.482 53.1674 26.6627C45.9095 31.8321 48.5288 40.8361 50.7458 44.6919C50.8709 37.4326 54.2923 31.72 55.9873 29.7712C54.1136 38.9242 58.7494 60.7306 59.654 59.6096Z",
    fill: "#2D2D2D",
    stroke: "#2D2D2D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.2071,
    cy: 29.9563,
    rx: 2.13213,
    ry: 2.23874,
    fill: "#09DE1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0691 41.9989C96.5728 39.6338 99.577 38.8159 102.152 39.9224L125.515 49.9618C128.56 51.27 129.968 54.7987 128.659 57.8432L127.226 61.1795C125.917 64.224 122.398 65.6356 119.354 64.3273C110.527 60.5343 93.9495 53.411 91.5779 52.392C89.5072 51.5021 92.5674 45.934 95.0691 41.9989Z",
    fill: "#09DE1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3147 42.7241C89.7702 41.7484 94.534 44.2015 94.534 44.2015L90.9981 52.43L83.0176 49.0007C83.0176 49.0007 84.8592 43.6997 87.3147 42.7241Z",
    fill: "#09DE1F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.2975,
    y: 48.2583,
    width: 45.4611,
    height: 0.792925,
    transform: "rotate(23.2535 83.2975 48.2583)",
    fill: "#414141"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102.423,
    y: 45.2571,
    width: 4.75755,
    height: 8.98649,
    transform: "rotate(23.2535 102.423 45.2571)",
    fill: "#414141"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5948,
    y: 42.7527,
    width: 4.75755,
    height: 5.02186,
    transform: "rotate(23.2535 96.5948 42.7527)",
    fill: "#414141"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98.6323,
    y: 53.4089,
    width: 4.75755,
    height: 0.792925,
    transform: "rotate(23.2535 98.6323 53.4089)",
    fill: "#4B4848"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 98.1809,
    y: 53.7903,
    width: 4.75755,
    height: 0.792925,
    transform: "rotate(23.2535 98.1809 53.7903)",
    fill: "#4B4848"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 109.223,
    y: 48.179,
    width: 4.75755,
    height: 5.55048,
    transform: "rotate(23.2535 109.223 48.179)",
    fill: "#414141"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 115.909,
    y: 50.8093,
    width: 4.75755,
    height: 5.55048,
    transform: "rotate(23.2535 115.909 50.8093)",
    fill: "#414141"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 122.336,
    y: 53.8137,
    width: 4.75755,
    height: 5.55048,
    transform: "rotate(23.2535 122.336 53.8137)",
    fill: "#414141"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 125.31,
    y: 64.2976,
    width: 0.528617,
    height: 2.37878,
    transform: "rotate(23.2535 125.31 64.2976)",
    fill: "#414141"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.969 53.1353L111.337 52.8276",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.422 56.1958L117.79 55.8882",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.493 58.804L123.861 58.4963",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.347 50.5662L110.715 50.2585",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.904 53.3838L117.272 53.0761",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.461 56.2009L123.828 55.8933",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.9759,
    cy: 52.8486,
    r: 3.56816,
    transform: "rotate(23.2535 92.9759 52.8486)",
    fill: "#030303"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.976,
    cy: 52.849,
    r: 1.82373,
    transform: "rotate(23.2535 92.976 52.849)",
    fill: "#BEBEBE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.855,
    cy: 64.2566,
    r: 3.56816,
    transform: "rotate(23.2535 118.855 64.2566)",
    fill: "#030303"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.855,
    cy: 64.2572,
    r: 1.82373,
    transform: "rotate(23.2535 118.855 64.2572)",
    fill: "#BEBEBE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5916 75.4288C55.1238 74.0992 71.0866 75.4288 86.7215 75.4288C93.4276 75.4288 100.474 75.904 106.967 75.904",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7328 82.1372C48.704 82.1372 71.6957 81.7074 94.6007 83.3664",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8618 78.0356H118.267",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.967 75.4778C114.044 74.6499 121.551 74.1985 128.715 74.1985",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4384 85.4462C111.416 85.4462 124.4 85.5833 137.377 85.4136C138.273 85.4019 141.467 85.4071 142.913 85.1526C143.343 85.0768 142.063 84.9234 141.631 84.8589",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6066 79.1021H73.2793",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5797 76.5281C22.1939 76.5281 30.8081 76.5281 39.4224 76.5281C41.4725 76.5281 45.0055 75.8643 46.8409 76.9702",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2913 91.682C43.4977 90.9739 58.695 90.8291 73.9189 90.8291",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6306 82.0872C48.3419 82.5081 79.0181 82.94 109.739 82.94",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1532 89.3364H89.6968",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2252 79.1021C55.0848 79.3242 82.9418 79.3152 110.805 79.3152",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6066 81.4475C52.7782 82.5815 68.9882 83.2755 85.1977 83.4375C93.3987 83.5195 101.568 83.6796 109.739 84.4325",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4354 91.6819H94.6006",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3214 81.021C38.9999 83.5199 55.7777 83.7928 72.6397 83.7928",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.042 71C26.8748 71.0438 32.694 71.4264 38.5255 71.4264",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.087 85.925C25.8303 87.1152 39.5821 86.5507 53.2372 88.6968",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4024 102.129H67.7358",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5856 90.4026H135.538",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M113.15 83.7925C117.514 83.7414 121.687 83.3328 125.943 82.5132",
    stroke: "#007BD5",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8889 39.0183H93.5345",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7719 27.5042H92.6818",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6367 60.979H40.0181",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0931 54.5823H34.048",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0761 19.1083C73.8087 15.4715 77.1283 10.5094 78.9104 9.321C94.3256 -0.958911 108.252 11.1929 111.104 17.0225C116.879 16.1667 117.895 20.3384 117.575 24.7239C117.318 28.2324 92.8324 29.573 80.6217 29.8047C75.0173 30.2326 72.6636 27.5318 72.1466 25.9452C72.1488 25.9422 72.1511 25.9394 72.1534 25.9367C71.9963 25.6553 71.7921 25.2621 71.5305 24.7239C69.6884 20.9335 75.0244 19.2865 76.0761 19.1083Z",
    fill: "#00A3FF",
    stroke: "#00A3FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86126 44.1474C3.62502 40.5422 6.89897 35.6233 8.65656 34.4452C23.8596 24.2547 37.5941 36.3008 40.407 42.0797C46.103 41.2315 47.1051 45.3668 46.7887 49.7142C46.5355 53.1922 22.3869 54.5211 10.3443 54.7509C4.81698 55.175 2.49566 52.4977 1.98582 50.9249C1.98803 50.9219 1.99025 50.9191 1.9925 50.9164C1.83759 50.6375 1.63619 50.2477 1.37823 49.7142C-0.438538 45.9568 4.82401 44.3241 5.86126 44.1474Z",
    fill: "#00A3FF",
    stroke: "#00A3FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M151.328 25.864C153.077 25.864 155.851 25.7787 159.648 25.608C163.488 25.4373 166.965 25.352 170.08 25.352C176.565 25.352 181.195 26.6533 183.968 29.256C186.741 31.816 188.128 35.4 188.128 40.008C188.128 42.7813 187.168 45.2773 185.248 47.496C183.328 49.7147 180.811 51.3787 177.696 52.488C179.531 55.6027 181.237 58.5253 182.816 61.256C184.437 63.9867 185.611 66.0133 186.336 67.336C187.061 68.6587 187.723 69.8533 188.32 70.92C188.917 71.944 189.344 72.648 189.6 73.032C189.899 73.416 190.176 73.736 190.432 73.992L195.04 74.632C195.211 75.272 195.211 76.0613 195.04 77H184.16L174.496 59.464C173.216 57.032 172 55.1547 170.848 53.832H169.952C167.776 53.832 165.579 53.704 163.36 53.448V74.184L169.184 74.824C169.355 75.464 169.355 76.2533 169.184 77.192C166.496 77.064 163.467 77 160.096 77C157.579 77 154.528 77.0427 150.944 77.128C150.688 76.36 150.688 75.592 150.944 74.824L156.256 74.056C156.427 72.4347 156.512 69.9387 156.512 66.568V28.872L151.328 28.232C151.157 27.592 151.157 26.8027 151.328 25.864ZM163.36 36.488V50.824C164.683 50.9947 166.603 51.08 169.12 51.08C171.296 51.08 173.152 50.7387 174.688 50.056C176.267 49.3307 177.44 48.392 178.208 47.24C178.976 46.0453 179.531 44.8293 179.872 43.592C180.213 42.3547 180.384 41.0533 180.384 39.688C180.384 36.0187 179.467 33.16 177.632 31.112C175.797 29.064 172.747 28.04 168.48 28.04C166.901 28.04 165.323 28.1893 163.744 28.488C163.488 30.92 163.36 33.5867 163.36 36.488ZM223.004 58.952H202.908C202.524 69.832 205.788 75.272 212.7 75.272C215.644 75.272 218.652 73.9707 221.724 71.368C222.364 71.752 222.855 72.4133 223.196 73.352C220.252 76.6373 216.519 78.28 211.996 78.28C201.585 78.28 196.38 72.1573 196.38 59.912C196.38 54.1093 197.916 49.608 200.988 46.408C204.06 43.1653 207.644 41.544 211.74 41.544C216.22 41.544 219.441 43.1013 221.404 46.216C223.367 49.3307 224.348 53.384 224.348 58.376C223.921 58.7173 223.473 58.9093 223.004 58.952ZM211.612 44.104C209.393 44.104 207.495 45.256 205.916 47.56C204.38 49.864 203.441 52.808 203.1 56.392H211.036C214.193 56.392 216.455 56.2 217.82 55.816C217.82 52.3173 217.287 49.5013 216.22 47.368C215.153 45.192 213.617 44.104 211.612 44.104ZM240.373 58.568L253.749 45.64L249.525 45.128C249.354 44.4453 249.354 43.6133 249.525 42.632C251.872 42.8027 254.069 42.888 256.117 42.888C257.781 42.888 260 42.824 262.773 42.696C263.029 43.464 263.029 44.2747 262.773 45.128L257.717 46.024L246.389 56.648L260.341 73.352L265.333 74.632C265.504 75.3147 265.504 76.168 265.333 77.192C262.645 77.064 259.957 77 257.269 77C255.434 77 252.725 77.0427 249.141 77.128C248.885 76.2747 248.885 75.4427 249.141 74.632L253.365 74.056L240.373 58.568ZM239.669 36.424V73.736L244.853 74.696C245.024 75.3787 245.024 76.232 244.853 77.256C242.165 77.128 239.434 77.064 236.661 77.064C234.698 77.064 231.925 77.1067 228.341 77.192C228.085 76.3813 228.085 75.5493 228.341 74.696L233.397 73.992C233.568 71.6453 233.653 68.936 233.653 65.864V29.192L228.405 28.552C228.234 27.912 228.234 27.1013 228.405 26.12C231.264 25.9067 234.912 25.4587 239.349 24.776C239.733 25.2027 239.946 25.6293 239.989 26.056C239.776 27.1653 239.669 30.6213 239.669 36.424ZM268.703 25.864C270.879 25.864 274.015 25.7787 278.111 25.608C282.207 25.4373 284.916 25.352 286.239 25.352H287.967C293.556 25.352 297.716 26.504 300.447 28.808C303.178 31.0693 304.543 34.056 304.543 37.768C304.543 43.0587 301.087 46.728 294.175 48.776V48.968C298.186 49.5653 301.343 51.144 303.647 53.704C305.994 56.2213 307.167 59.2507 307.167 62.792C307.167 67.528 305.546 71.2187 302.303 73.864C299.103 76.5093 294.388 77.832 288.159 77.832C286.452 77.832 283.679 77.6827 279.839 77.384C276.042 77.128 273.012 77 270.751 77C270.495 77 270.09 77 269.535 77C268.98 77.0427 268.575 77.064 268.319 77.064C268.063 76.296 268.063 75.528 268.319 74.76L273.631 74.056C273.802 72.4347 273.887 69.9387 273.887 66.568V28.872L268.703 28.232C268.532 27.592 268.532 26.8027 268.703 25.864ZM285.855 51.016H280.735V74.184C282.911 74.568 284.639 74.8027 285.919 74.888C291.082 74.888 294.644 73.928 296.607 72.008C298.57 70.0453 299.551 66.9947 299.551 62.856C299.551 59.528 298.335 56.7333 295.903 54.472C293.514 52.168 290.164 51.016 285.855 51.016ZM286.303 28.04C284.17 28.04 282.399 28.1893 280.991 28.488C280.82 30.1093 280.735 32.776 280.735 36.488V47.816H285.727C289.695 47.816 292.575 47.0053 294.367 45.384C296.202 43.7627 297.119 41.352 297.119 38.152C297.119 34.9093 296.116 32.4133 294.111 30.664C292.148 28.9147 289.546 28.04 286.303 28.04ZM313.328 25.864C315.504 25.864 318.64 25.7787 322.736 25.608C326.832 25.4373 329.541 25.352 330.864 25.352H332.592C338.181 25.352 342.341 26.504 345.072 28.808C347.803 31.0693 349.168 34.056 349.168 37.768C349.168 43.0587 345.712 46.728 338.8 48.776V48.968C342.811 49.5653 345.968 51.144 348.272 53.704C350.619 56.2213 351.792 59.2507 351.792 62.792C351.792 67.528 350.171 71.2187 346.928 73.864C343.728 76.5093 339.013 77.832 332.784 77.832C331.077 77.832 328.304 77.6827 324.464 77.384C320.667 77.128 317.637 77 315.376 77C315.12 77 314.715 77 314.16 77C313.605 77.0427 313.2 77.064 312.944 77.064C312.688 76.296 312.688 75.528 312.944 74.76L318.256 74.056C318.427 72.4347 318.512 69.9387 318.512 66.568V28.872L313.328 28.232C313.157 27.592 313.157 26.8027 313.328 25.864ZM330.48 51.016H325.36V74.184C327.536 74.568 329.264 74.8027 330.544 74.888C335.707 74.888 339.269 73.928 341.232 72.008C343.195 70.0453 344.176 66.9947 344.176 62.856C344.176 59.528 342.96 56.7333 340.528 54.472C338.139 52.168 334.789 51.016 330.48 51.016ZM330.928 28.04C328.795 28.04 327.024 28.1893 325.616 28.488C325.445 30.1093 325.36 32.776 325.36 36.488V47.816H330.352C334.32 47.816 337.2 47.0053 338.992 45.384C340.827 43.7627 341.744 41.352 341.744 38.152C341.744 34.9093 340.741 32.4133 338.736 30.664C336.773 28.9147 334.171 28.04 330.928 28.04Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logoFooter.96f06c19d27c3dcc126d4867908a61a5.svg";
export { ForwardRef as ReactComponent };